import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
	providedIn: 'root'
})
export class DateRangeService {
	syncEndDate(
		startControl: AbstractControl | null | undefined,
		endControl: AbstractControl | null | undefined,
		callback?: (minEndDate: Date | null) => void
	): void {
		startControl?.valueChanges
		.subscribe((startDate) => {
			if (startDate) {
				const minEndDate = new Date(startDate);
				minEndDate.setDate(minEndDate.getDate() + 1);

				endControl?.enable({ emitEvent: false });

				if (callback) {
					callback(minEndDate);
				}
			} else {
				endControl?.patchValue(null, { emitEvent: false });
				endControl?.disable({ emitEvent: false });

				if (callback) {
					callback(null);
				}
			}
		});
	}
}
